import { render, staticRenderFns } from "./CompanyCalendar.vue?vue&type=template&id=6f04c03c&lang=pug&"
import script from "./CompanyCalendar.vue?vue&type=script&lang=ts&"
export * from "./CompanyCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyCalendar.vue?vue&type=style&index=0&id=6f04c03c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports